import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import TopMenuBarOwnProps from './TopMenuBarOwnProps';
import TopMenuBarScreen from './TopMenuBarScreen';
import { iRootDispatch, iRootState } from '../../../store/store';
import TopMenuBarScreenDispatchProps from './TopMenuBarScreenDispatchProps';

const mapStateToProps = (state: iRootState, ownProps: RouteComponentProps<TopMenuBarOwnProps>) => ({
    user: state.Identity.userProfile,
    value: 'value' /*ownProps.match.params.orderId || ownProps.match.params.organizationId || ownProps.match.params.warehouseId
        || ownProps.match.params.userType*/,
    //userId: ownProps.match.params.userId ? Number(ownProps.match.params.userId) : undefined,
    //reportId: ownProps.match.params.reportId ? Number(ownProps.match.params.reportId) : undefined,
});
const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: any) =>
    ({
        // @ts-ignore
        logoutUser: _dispatch.Identity.logout,
        //
        // @ts-ignore
        cosOrderById: _dispatch.COSOrders.singleByIdWithKeys,
        ..._ownDispatch,
    } as TopMenuBarScreenDispatchProps);

export const TopMenuBarScreenContainer = withRouter(
    connect(mapStateToProps, mapDispatch as any)(TopMenuBarScreen as any)
);
